import { FC, useEffect } from 'react'

import { useAppDispatch, useAppSelector } from '../../app/hook'
import { LeaderBoardLayout } from '../../components'
import { fetchMyProfile } from '../MyProfile/myProfileSlice'
import { LeaderBoardTabs } from './components'
import {
    fetchLeaderBoard,
    fetchMyRankingLeaderBoard,
    searchUserTag,
} from './leaderBoardSlice'

export const LeaderBoard: FC<unknown> = () => {
    const { rank, searchResults, status } = useAppSelector(
        (state) => state.leaderBoard
    )
    const { user } = useAppSelector((state) => state.profile)
    const dispatch = useAppDispatch()

    useEffect(() => {
        dispatch(fetchMyProfile())
        dispatch(fetchLeaderBoard({ limit: 100, page: 1, boardName: 'mock' }))

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        window.localStorage.getItem('APP_USER_ID') &&
            window.localStorage.getItem('MOCK_ACC_ID'),
    ])

    const onTop100Handler = () => {
        dispatch(fetchLeaderBoard({ limit: 100, page: 1, boardName: 'mock' }))
    }

    const onMyRankHandler = () => {
        const userRank = user?.rank || 0
        const page = (userRank && Math.floor(userRank / 100) + 1) || 1

        dispatch(
            fetchMyRankingLeaderBoard({
                limit: 100,
                page: page,
                boardName: 'mock',
                stats: false,
                userRank,
            })
        )
    }

    const onSearchUserTag = async (value: string) => {
        await dispatch(searchUserTag(value))
    }

    return (
        <LeaderBoardLayout>
            {rank && (
                <LeaderBoardTabs
                    rank={rank}
                    searchResults={searchResults}
                    user={user}
                    onTop100Handler={onTop100Handler}
                    onMyRankHandler={onMyRankHandler}
                    onSearchUserTag={onSearchUserTag}
                    status={status}
                />
            )}
        </LeaderBoardLayout>
    )
}
